/* @flow */
import React from 'react';

import ButtonTemplate from 'components/UIKit/Button/ButtonTemplate';
import OpenIcon from 'components/icons/OpenIcon';
import { Spinner } from 'components/UIKit/Spinner';
import { setModal } from 'ducks/modal';
import Open from 'components/Open';

export default function OpenButton({
  handleOnClick,
  style,
  children,
  isFetching,
  isDisabled,
  dispatch,
  params,
  ...props
}: Object): React.Element {
  let customStyles = {
    content: {
      position: 'initial',
      bottom: 'auto',
      right: 'auto',
      left: 'auto',
      top: 'auto',
      width: '60rem'
    }
  };
  return (
    <ButtonTemplate
      style={style}
      onClick={() => dispatch(setModal({
        Component: () => <Open params={params} handleOnClick={handleOnClick} closeModal={() => dispatch(setModal({Component: null}))} />,
        style: customStyles
      }))}
      disabled={isFetching || isDisabled}
      PrefixComponent={
        isFetching
          ? <Spinner style={{ width: '14px', height: '14px', margin: '0 0.25rem' }} />
          : <OpenIcon style={{ margin: '0 .25rem' }} />
      }>
      { children || 'Open' }
    </ButtonTemplate>
  );
}
